
/*import React, { useState } from 'react';
import styled from 'styled-components';
import HeaderLogo from './HeaderLogo';
import HeaderTop from './HeaderTop';
import { useAuth } from '../../../context/AuthContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import loginService from '../../../services/login.service';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const { isLogged, setIsLogged } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const handleLogout = () => {
    setIsLogged(false);
    loginService.logOut();
    navigate('/');
  };

  return (
    <HeaderContainer>
      <HeaderTop />
      <HeaderWrapper>
        <Logo href="/" aria-label="Go to homepage">
          <HeaderLogo />
        </Logo>
        <Navigation className={isMenuOpen ? 'open' : ''}>
          <DropdownNavLink
            onClick={() => toggleDropdown('about')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'about'}
          >
            ABOUT
            <Submenu className={activeDropdown === 'about' ? 'open' : ''}>
              <li><Link to="/history" style={{ color: 'white' }} aria-label="Learn about our history">OUR HISTORY</Link></li>
              <li><Link to="/mission" style={{ color: 'white' }} aria-label="Learn about our mission and vision">MISSION & VISION</Link></li>
              <li><Link to="/team" style={{ color: 'white' }} aria-label="Meet our leaders">OUR LEADERS</Link></li>
              <li><a href="https://repository.admasuniversity.edu.et/staff_profile" target='_blank' style={{ color: 'white' }} aria-label="View staff profiles">ADU STAFF PROFILES</a></li>
            </Submenu>
          </DropdownNavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('admission')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'admission'}
          >
            ADMISSION
            <Submenu className={activeDropdown === 'admission' ? 'open' : ''}>
              <li><Link to="/overview" style={{ color: 'white' }} aria-label="Overview of admission process">OVERVIEW</Link></li>
              <li><Link to="/userUpcomingEvents" style={{ color: 'white' }} aria-label="View upcoming events calendar">CALENDAR</Link></li>
              <li><a href="https://aurs.admasuniversity.edu.et/Login" target='_blank' style={{ color: 'white' }} aria-label="Access the registrar portal">REGISTRAR</a></li>
            </Submenu>
          </DropdownNavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('academic')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'academic'}
          >
            ACADEMIC PROGRAMS
            <Submenu className={activeDropdown === 'academic' ? 'open' : ''}>
              <li><Link to="/postgrad" style={{ color: 'white' }} aria-label="Postgraduate studies">SCHOOL OF POSTGRADUATE STUDIES</Link></li>
              <li><Link to="/undergrad" style={{ color: 'white' }} aria-label="Undergraduate programs">UNDERGRADUATE ACADEMIC PROGRAMS</Link></li>
              <li><Link to="/distance" style={{ color: 'white' }} aria-label="Distance learning programs">DISTANCE LEARNING PROGRAM</Link></li>
              <li><Link to="/tvet" style={{ color: 'white' }} aria-label="Technical and Vocational Education and Training programs">TVET PROGRAMS</Link></li>
            </Submenu>
          </DropdownNavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('offices')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'offices'}
          >
            OFFICES
            <Submenu className={activeDropdown === 'offices' ? 'open' : ''}>
              <li><Link to="/presidentoffice" style={{ color: 'white' }} aria-label="Visit the President's Office">PRESIDENT OFFICE</Link></li>
              <li><Link to="/acdemicPresident" style={{ color: 'white' }} aria-label="Visit the Academic Vice President's Office">ACADEMIC VICE PRESIDENT</Link></li>
              <li><Link to="/adminoffice" style={{ color: 'white' }} aria-label="Visit the Admin & Finance Vice President's Office">ADMIN & FINANCE VICE PRESIDENT</Link></li>
              <li><Link to="/centralICT" style={{ color: 'white' }} aria-label="Visit the Central ICT Office">CENTRAL ICT</Link></li>
              <li><Link to="/centralRegistrar" style={{ color: 'white' }} aria-label="Visit the Central Registrar's Office">CENTRAL REGISTRAR</Link></li>
              <li><Link to="#" style={{ color: 'white' }} aria-label="Visit the Central Library Office">CENTRAL LIBRARY OFFICE</Link></li>
              <li><Link to="/centralQuaity" style={{ color: 'white' }} aria-label="Visit the Central Quality Assurance Office">CENTRAL QUALITY ASSURANCE</Link></li>
            </Submenu>
          </DropdownNavLink>

          <NavLink href="/allannouncement" style={{ color: 'white' }} aria-label="View blog and articles">BLOG & ARTICLES</NavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('eservice')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'eservice'}
          >
            E-SERVICES
            <Submenu className={activeDropdown === 'eservice' ? 'open' : ''}>
              <li><a href="https://lms.admasuniversity.edu.et/login/index.php" target='_blank' style={{ color: 'white' }} aria-label="Login to the LMS">LMS</a></li>
              <li><a href="http://5.77.63.215:8080/" target='_blank' style={{ color: 'white' }} aria-label="Visit the library">LIBRARY</a></li>
              <li><a href="https://repository.admasuniversity.edu.et/" target='_blank' style={{ color: 'white' }} aria-label="Access the repository and digital library">REPOSITORY & DIGITAL LIBRARY</a></li>
              <li><Link to="/vacancy" style={{ color: 'white' }} aria-label="View job vacancies">VACANCY</Link></li>
            </Submenu>
          </DropdownNavLink>

          <NavLink href="/contact" style={{ color: 'white' }} aria-label="Contact us">CONTACT US</NavLink>
        </Navigation>

        <MenuButton onClick={toggleMenu} aria-label="Toggle menu">
          <Hamburger className={isMenuOpen ? 'open' : ''}>
            <span></span>
            <span></span>
            <span></span>
          </Hamburger>
        </MenuButton>

        <div className="search-btn">
          {location.pathname.includes('/ad-adm') && (
            <div className="link-btn">
              {isLogged ? (
                <Link to="/" className="theme-btn btn-style-one blue" onClick={handleLogout} aria-label="Log out">
                  Log out
                </Link>
              ) : (
                <Link to="/login" className="theme-btn btn-style-one" aria-label="Login">
                  Login
                </Link>
              )}
            </div>
          )}
        </div>
      </HeaderWrapper>
    </HeaderContainer>
  );
};

export default Header;

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #1ab5f1;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 100;
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 4px;
`;

const Logo = styled.a`
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  text-decoration: none;
`;

const Navigation = styled.nav`
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 1rem;
	color: #FFF;
  
  @media (max-width: 768px) {
    position: fixed;
    top: 168px;
    right: 0;
    width: 77%;
    height: 100vh;
    background: rgb(8, 8, 81);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    flex-direction: column;
    align-items: flex-start;
    padding: 2rem;
    transform: translateX(100%);
    transition: transform 0.3s ease;

    &.open {
      transform: translateX(0);
    }
  }
`;

const NavLink = styled.a`
  color: #FFF; 
  text-decoration: none;
  margin-left: 1rem;
  transition: color 0.3s ease;
  font-weight: bold;

  &:hover {
    color: #daa520;
  }

  @media (max-width: 768px) {
    margin-left: 0;
    margin-bottom: 1.5rem;
  }
`;

const DropdownNavLink = styled(NavLink)`
  position: relative;
  cursor: pointer;

  &.open {
    color: #fff;
  }
`;

const Submenu = styled.ul`
  display: none;
  position: absolute;
  background-color: rgba(11, 156, 213, 0.90);
  min-width: 260px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  padding: 0;
  margin: 0;
  list-style-type: none;

  li {
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    color: #fff; 

    &:hover {
      background-color: #1ab5f1;
      color: #fff;
    }
  }

  &.open {
    display: block;
  }
`;

const MenuButton = styled.button`
  display: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Hamburger = styled.div`
  span {
    display: block;
    width: 25px;
    height: 3px;
    background-color: #f5f7f7;
    margin-bottom: 5px;
    transition: all 0.3s ease;

    &:first-child,
    &:last-child {
      transform-origin: center;
    }

    &:first-child {
      transform: ${({ className }) =>
        className === 'open' ? 'translateY(8px) rotate(45deg)' : 'none'};
    }

    &:nth-child(2) {
      opacity: ${({ className }) => (className === 'open' ? '0' : '1')};
    }

    &:last-child {
      transform: ${({ className }) =>
        className === 'open' ? 'translateY(-8px) rotate(-45deg)' : 'none'};
    }
  }
`;

*/



/*

import React, { useState } from 'react';
import styled from 'styled-components';
import HeaderLogo from './HeaderLogo';
import HeaderTop from './HeaderTop';
import { useAuth } from '../../../context/AuthContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import loginService from '../../../services/login.service';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const { isLogged, setIsLogged } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const handleLogout = () => {
    setIsLogged(false);
    loginService.logOut();
    navigate('/');
  };

  // Function to handle submenu item click
  const handleSubmenuClick = () => {
    setActiveDropdown(null); // Close the dropdown
    setIsMenuOpen(false); // Close the main menu
  };

  return (
    <HeaderContainer>
      <HeaderTop />
      <HeaderWrapper>
        <Logo href="/" aria-label="Go to homepage">
          <HeaderLogo />
        </Logo>
        <Navigation className={isMenuOpen ? 'open' : ''}>
          <DropdownNavLink
            onClick={() => toggleDropdown('about')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'about'}
          >
            ABOUT
            <Submenu className={activeDropdown === 'about' ? 'open' : ''}>
              <li>
                <Link to="/history" style={{ color: 'white' }} onClick={handleSubmenuClick}>OUR HISTORY</Link>
              </li>
              <li>
                <Link to="/mission" style={{ color: 'white' }} onClick={handleSubmenuClick}>MISSION & VISION</Link>
              </li>
              <li>
                <Link to="/team" style={{ color: 'white' }} onClick={handleSubmenuClick}>OUR LEADERS</Link>
              </li>
              <li>
                <a href="https://repository.admasuniversity.edu.et/staff_profile" target='_blank' style={{ color: 'white' }}>ADU STAFF PROFILES</a>
              </li>
            </Submenu>
          </DropdownNavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('admission')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'admission'}
          >
            ADMISSION
            <Submenu className={activeDropdown === 'admission' ? 'open' : ''}>
              <li>
                <Link to="/overview" style={{ color: 'white' }} onClick={handleSubmenuClick}>OVERVIEW</Link>
              </li>
              <li>
                <Link to="/userUpcomingEvents" style={{ color: 'white' }} onClick={handleSubmenuClick}>CALENDAR</Link>
              </li>
              <li>
                <a href="https://aurs.admasuniversity.edu.et/Login" target='_blank' style={{ color: 'white' }} onClick={handleSubmenuClick}>REGISTRAR</a>
              </li>
            </Submenu>
          </DropdownNavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('academic')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'academic'}
          >
            ACADEMIC PROGRAMS
            <Submenu className={activeDropdown === 'academic' ? 'open' : ''}>
              <li>
                <Link to="/postgrad" style={{ color: 'white' }} onClick={handleSubmenuClick}>SCHOOL OF POSTGRADUATE STUDIES</Link>
              </li>
              <li>
                <Link to="/undergrad" style={{ color: 'white' }} onClick={handleSubmenuClick}>UNDERGRADUATE ACADEMIC PROGRAMS</Link>
              </li>
              <li>
                <Link to="/distance" style={{ color: 'white' }} onClick={handleSubmenuClick}>DISTANCE LEARNING PROGRAM</Link>
              </li>
              <li>
                <Link to="/tvet" style={{ color: 'white' }} onClick={handleSubmenuClick}>TVET PROGRAMS</Link>
              </li>
            </Submenu>
          </DropdownNavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('offices')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'offices'}
          >
            OFFICES
            <Submenu className={activeDropdown === 'offices' ? 'open' : ''}>
              <li>
                <Link to="/presidentoffice" style={{ color: 'white' }} onClick={handleSubmenuClick}>PRESIDENT OFFICE</Link>
              </li>
              <li>
                <Link to="/acdemicPresident" style={{ color: 'white' }} onClick={handleSubmenuClick}>ACADEMIC VICE PRESIDENT</Link>
              </li>
              <li>
                <Link to="/adminoffice" style={{ color: 'white' }} onClick={handleSubmenuClick}>ADMIN & FINANCE VICE PRESIDENT</Link>
              </li>
              <li>
                <Link to="/centralICT" style={{ color: 'white' }} onClick={handleSubmenuClick}>CENTRAL ICT</Link>
              </li>
              <li>
                <Link to="/centralRegistrar" style={{ color: 'white' }} onClick={handleSubmenuClick}>CENTRAL REGISTRAR</Link>
              </li>
              <li>
                <Link to="#" style={{ color: 'white' }} onClick={handleSubmenuClick}>CENTRAL LIBRARY OFFICE</Link>
              </li>
              <li>
                <Link to="/centralQuaity" style={{ color: 'white' }} onClick={handleSubmenuClick}>CENTRAL QUALITY ASSURANCE</Link>
              </li>
            </Submenu>
          </DropdownNavLink>

          <NavLink href="/allannouncement" style={{ color: 'white' }} aria-label="View blog and articles">BLOG & ARTICLES</NavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('eservice')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'eservice'}
          >
            E-SERVICES
            <Submenu className={activeDropdown === 'eservice' ? 'open' : ''}>
              <li>
                <a href="https://lms.admasuniversity.edu.et/login/index.php" target='_blank' style={{ color: 'white' }} onClick={handleSubmenuClick}>LMS</a>
              </li>
              <li>
                <a href="http://5.77.63.215:8080/" target='_blank' style={{ color: 'white' }} onClick={handleSubmenuClick}>LIBRARY</a>
              </li>
              <li>
                <a href="https://repository.admasuniversity.edu.et/" target='_blank' style={{ color: 'white' }} onClick={handleSubmenuClick}>REPOSITORY & DIGITAL LIBRARY</a>
              </li>
              <li>
                <Link to="/vacancy" style={{ color: 'white' }} onClick={handleSubmenuClick}>VACANCY</Link>
              </li>
            </Submenu>
          </DropdownNavLink>

          <NavLink href="/contact" style={{ color: 'white' }} aria-label="Contact us">CONTACT US</NavLink>
        </Navigation>

        <MenuButton onClick={toggleMenu} aria-label="Toggle menu">
          <Hamburger className={isMenuOpen ? 'open' : ''}>
            <span></span>
            <span></span>
            <span></span>
          </Hamburger>
        </MenuButton>

        <div className="search-btn">
          {location.pathname.includes('/ad-adm') && (
            <div className="link-btn">
              {isLogged ? (
                <Link to="/" className="theme-btn btn-style-one blue" onClick={handleLogout} aria-label="Log out">
                  Log out
                </Link>
              ) : (
                <Link to="/login" className="theme-btn btn-style-one" aria-label="Login">
                  Login
                </Link>
              )}
            </div>
          )}
        </div>
      </HeaderWrapper>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #1ab5f1;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 100;
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 4px;
`;

const Logo = styled.a`
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  text-decoration: none;
`;

const Navigation = styled.nav`
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 1rem;
  color: #FFF;
  
  @media (max-width: 768px) {
    position: fixed;
    top: 168px;
    right: 0;
    width: 77%;
    height: 100vh;
    background: rgb(8, 8, 81);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    flex-direction: column;
    align-items: flex-start;
    padding: 2rem;
    transform: translateX(100%);
    transition: transform 0.3s ease;

    &.open {
      transform: translateX(0);
    }
  }
`;

const NavLink = styled.a`
  color: #FFF; 
  text-decoration: none;
  margin-left: 1rem;
  transition: color 0.3s ease;
  font-weight: bold;

  &:hover {
    color: #daa520;
  }

  @media (max-width: 768px) {
    margin-left: 0;
    margin-bottom: 1.5rem;
  }
`;

const DropdownNavLink = styled(NavLink)`
  position: relative;
  cursor: pointer;

  &.open {
    color: #fff;
  }
`;

const Submenu = styled.ul`
  display: none;
  position: absolute;
  background-color: rgba(11, 156, 213, 0.90);
  min-width: 260px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  padding: 0;
  margin: 0;
  list-style-type: none;

  li {
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    color: #fff; 

    &:hover {
      background-color: #1ab5f1;
      color: #fff;
    }
  }

  &.open {
    display: block;
  }
`;

const MenuButton = styled.button`
  display: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Hamburger = styled.div`
  span {
    display: block;
    width: 25px;
    height: 3px;
    background-color: #f5f7f7;
    margin-bottom: 5px;
    transition: all 0.3s ease;

    &:first-child,
    &:last-child {
      transform-origin: center;
    }

    &:first-child {
      transform: ${({ className }) =>
        className === 'open' ? 'translateY(8px) rotate(45deg)' : 'none'};
    }

    &:nth-child(2) {
      opacity: ${({ className }) => (className === 'open' ? '0' : '1')};
    }

    &:last-child {
      transform: ${({ className }) =>
        className === 'open' ? 'translateY(-8px) rotate(-45deg)' : 'none'};
    }
  }
`;

export default Header;
*/

/*
import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import HeaderLogo from './HeaderLogo';
import HeaderTop from './HeaderTop';
import NavLinks from './NavLink';
import { useAuth } from '../../../context/AuthContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import loginService from '../../../services/login.service';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const { isLogged, setIsLogged, employee } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
console.log(useAuth());
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleDropdownEnter = (dropdownName) => {
    setActiveDropdown(dropdownName);
  };

  const handleDropdownLeave = () => {
    setActiveDropdown(null);
  };

  const handleLogout = () => {
    setIsLogged(false);
    loginService.logOut();
    navigate('/');
  };

  return (
    <HeaderContainer>
      <HeaderTop />
      <HeaderWrapper>
        <Logo href="/"><HeaderLogo /></Logo>
        <Navigation className={isMenuOpen ? 'open' : ''}>
          
          <DropdownNavLink
            href="#"
            className={activeDropdown === 'about' ? 'open' : ''}
            onMouseEnter={() => handleDropdownEnter('about')}
            onMouseLeave={handleDropdownLeave}
          >
            ABOUT
            <Submenu className={activeDropdown === 'about' ? 'open' : ''}>
              <li><a href="/history" style={{color:'white'}}>OUR HISTORY</a></li>
              <li><a href="/mission" style={{color:'white'}}>MISSION & VISION</a></li>
              <li><a href="/team" style={{color:'white'}}>ADU LEADERS</a></li>
              <li><a href="https://repository.admasuniversity.edu.et/staff_profile" target='_blank' style={{color:'white'}}>ADU STAFF PROFILES</a></li>
              
            </Submenu>
          </DropdownNavLink>
      

          <DropdownNavLink
            href="#"
            className={activeDropdown === 'admission' ? 'open' : ''}
            onMouseEnter={() => handleDropdownEnter('admission')}
            onMouseLeave={handleDropdownLeave}
          >
            ADMISSION
            <Submenu className={activeDropdown === 'admission' ? 'open' : ''}>
              <li><a href="/overview" style={{color:'white'}}>OVERVIEW</a></li>
              <li><a href="/userUpcomingEvents" style={{color:'white'}}>CALANDER</a></li>
              <li><a href="https://aurs.admasuniversity.edu.et/Login" target='_blank'  style={{color:'white'}}>REGISTRAR</a></li>
              
            </Submenu>
          </DropdownNavLink>

     
          <DropdownNavLink
            href="#"
            className={activeDropdown === 'academic' ? 'open' : ''}
            onMouseEnter={() => handleDropdownEnter('academic')}
            onMouseLeave={handleDropdownLeave}
          >
            ACADEMIC PROGRAMS
            <Submenu className={activeDropdown === 'academic' ? 'open' : ''}>
              <li><a href="/postgrad"style={{color:'white'}}>SCHOOL OF POSTGRADUATE STUDIES</a></li>
              <li><a href="/undergrad" style={{color:'white'}}>UNDERGRADUATE ACADEMIC PROGRAMS</a></li>
              <li><a href="/distance"style={{color:'white'}}>DISTANCE LEARNING PROGRAM</a></li>
              <li><a href="/tvet"style={{color:'white'}}>TVET PROGRAMS</a></li>
            </Submenu>
          </DropdownNavLink>

          <DropdownNavLink
            href="#"
            className={activeDropdown === 'Outreach' ? 'open' : ''}
            onMouseEnter={() => handleDropdownEnter('Outreach')}
            onMouseLeave={handleDropdownLeave}
          >
            OFFICES
            <Submenu className={activeDropdown === 'Outreach' ? 'open' : ''}>
              
              <li><a href="/presidentoffice" style={{color:'white'}}>PRESIDENT OFFICE</a></li>
              <li><a href="/acdemicPresident" style={{color:'white'}}>ACADEMIC VICE PRESIDENT</a></li>
              <li><a href="/adminoffice" style={{color:'white'}}>ADMIN & FINANCE VICE PRESIDENT</a></li>
              <li><a href="#" style={{color:'white'}}>CENTRAL ICT</a>
              <li><a href="/training" style={{color:'white'}}>CONSULTANCY & TRAINING</a></li>
              
              </li>
              <li><a href="#" style={{color:'white'}}>CENTRAL LIBRARY OFFICE</a></li>
              <li><a href="/centralQuaity"style={{color:'white'}}>CENTRAL QUALITY ASSURANCE</a></li>
            </Submenu>
          </DropdownNavLink>
       
          <NavLink href="/allannouncement" style={{color:'white'}}>BLOG & ARTICLES</NavLink>
          <DropdownNavLink
            href="#"
            className={activeDropdown === 'eservice' ? 'open' : ''}
            onMouseEnter={() => handleDropdownEnter('eservice')}
            onMouseLeave={handleDropdownLeave}
          >
			  E-SERVICES
       
            <Submenu className={activeDropdown === 'eservice' ? 'open' : ''}>
              <li><a href="https://lms.admasuniversity.edu.et/login/index.php" target='_blank' style={{color:'white'}}>LMS</a></li>
              <li><a href="http://5.77.63.215:8080/" target='_blank' style={{color:'white'}}>LIBRARY</a></li>
              <li><a href="https://repository.admasuniversity.edu.et/" target='_blank' style={{color:'white'}}>REPOSITORY & DIGITAL LIBRARY</a></li> 
                      
              <li><a href="/vacancy" style={{color:'white'}}>VACANCY</a></li>          
           
            </Submenu>
          </DropdownNavLink>

          <NavLink href="/contact" style={{color:'white'}}>CONTACT</NavLink>
</Navigation>

        <MenuButton onClick={toggleMenu}>
          <Hamburger className={isMenuOpen ? 'open' : ''}>
            <span></span>
            <span></span>
            <span></span>
          </Hamburger>
        </MenuButton>
        <div className="search-btn">
          {location.pathname.includes('/ad-adm') && (
            <div className="link-btn">
              {isLogged ? (
                <Link to="/" className="theme-btn btn-style-one blue" onClick={handleLogout}>
                  Log out
                </Link>
              ) : (
                <Link to="/login" className="theme-btn btn-style-one">
                  Login
                </Link>
              )}
            </div>
          )}
        </div>
      </HeaderWrapper>
    </HeaderContainer>
  );
};

export default Header;


const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #1ab5f1;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 100;
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 4px;
`;

const Logo = styled.a`
  font-size: 1.2rem;
  font-weight: bold;
  color: #333;
  text-decoration: none;
`;

const Navigation = styled.nav`
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 1rem;

  @media (max-width: 768px) {
    position: fixed;
    top: 168px;
    right: 0;
    width: 77%;
    height: 100vh;
    background: rgb(8, 8, 81);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    flex-direction: column;
    align-items: flex-start;
    padding: 2rem;
    transform: translateX(100%);
    transition: transform 0.3s ease;

    &.open {
      transform: translateX(0);
    }
  }
`;

const NavLink = styled.a`
  color: #fff; 
  text-decoration: none;
  margin-left: 1rem;
  transition: color 0.3s ease;

  &:hover {
    color: #daa520;
  }

  @media (max-width: 768px) {
    margin-left: 0;
    margin-bottom: 1.5rem;
  }
`;

const DropdownNavLink = styled(NavLink)`
  position: relative;
  cursor: pointer;

  &.open {
    color: #fff;
  }
`;

const Submenu = styled.ul`
  display: none;
  position: absolute;
  background-color: rgba(11, 156, 213, 0.73);
  min-width: 260px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  padding: 0;
  margin: 0;
  list-style-type: none;

  li {
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    color: #fff; 

    &:hover {
      background-color: #1ab5f1;
      color: #fff;
    }
  }

  &.open {
    display: block;
  }
`;

const MenuButton = styled.button`
  display: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Hamburger = styled.div`
  span {
    display: block;
    width: 25px;
    height: 3px;
    background-color: #333;
    margin-bottom: 5px;
    transition: all 0.3s ease;

    &:first-child,
    &:last-child {
      transform-origin: center;
    }

    &:first-child {
      transform: ${({ className }) =>
        className === 'open' ? 'translateY(8px) rotate(45deg)' : 'none'};
    }

    &:nth-child(2) {
      opacity: ${({ className }) => (className === 'open' ? '0' : '1')};
    }

    &:last-child {
      transform: ${({ className }) =>
        className === 'open' ? 'translateY(-8px) rotate(-45deg)' : 'none'};
    }
  }
`;

// Styled components for the AdminButton
const AdminButton = styled.a`
  padding: 10px 20px;
  background-color: #daa520;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  margin-left: 20px;
`;

*/

/*
import React, { useState } from 'react';
import styled from 'styled-components';
import HeaderLogo from './HeaderLogo';
import HeaderTop from './HeaderTop';
import { useAuth } from '../../../context/AuthContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import loginService from '../../../services/login.service';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const { isLogged, setIsLogged } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const handleLogout = () => {
    setIsLogged(false);
    loginService.logOut();
    navigate('/');
  };

  // Function to handle submenu item click
  const handleSubmenuClick = () => {
    setActiveDropdown(null); // Close the dropdown
    if (isMenuOpen) {
      setIsMenuOpen(false); // Close the main menu on mobile
    }
  };

  return (
    <HeaderContainer>
      <HeaderTop />
      <HeaderWrapper>
        <Logo href="/" aria-label="Go to homepage">
          <HeaderLogo />
        </Logo>
        <Navigation className={isMenuOpen ? 'open' : ''}>
          <DropdownNavLink
            onClick={() => toggleDropdown('about')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'about'}
          >
            ABOUT
            <Submenu className={activeDropdown === 'about' ? 'open' : ''}>
              <li>
                <Link to="/history" style={{ color: 'white' }} onClick={handleSubmenuClick}>OUR HISTORY</Link>
              </li>
              <li>
                <Link to="/mission" style={{ color: 'white' }} onClick={handleSubmenuClick}>MISSION & VISION</Link>
              </li>
              <li>
                <Link to="/team" style={{ color: 'white' }} onClick={handleSubmenuClick}>OUR LEADERS</Link>
              </li>
              <li>
                <a href="https://repository.admasuniversity.edu.et/staff_profile" target='_blank' style={{ color: 'white' }}>ADU STAFF PROFILES</a>
              </li>
            </Submenu>
          </DropdownNavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('admission')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'admission'}
          >
            ADMISSION
            <Submenu className={activeDropdown === 'admission' ? 'open' : ''}>
              <li>
                <Link to="/overview" style={{ color: 'white' }} onClick={handleSubmenuClick}>OVERVIEW</Link>
              </li>
              <li>
                <Link to="/userUpcomingEvents" style={{ color: 'white' }} onClick={handleSubmenuClick}>CALENDAR</Link>
              </li>
              <li>
                <a href="https://aurs.admasuniversity.edu.et/Login" target='_blank' style={{ color: 'white' }} onClick={handleSubmenuClick}>REGISTRAR</a>
              </li>
            </Submenu>
          </DropdownNavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('academic')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'academic'}
          >
            ACADEMIC PROGRAMS
            <Submenu className={activeDropdown === 'academic' ? 'open' : ''}>
              <li>
                <Link to="/postgrad" style={{ color: 'white' }} onClick={handleSubmenuClick}>SCHOOL OF POSTGRADUATE STUDIES</Link>
              </li>
              <li>
                <Link to="/undergrad" style={{ color: 'white' }} onClick={handleSubmenuClick}>UNDERGRADUATE ACADEMIC PROGRAMS</Link>
              </li>
              <li>
                <Link to="/distance" style={{ color: 'white' }} onClick={handleSubmenuClick}>DISTANCE LEARNING PROGRAM</Link>
              </li>
              <li>
                <Link to="/tvet" style={{ color: 'white' }} onClick={handleSubmenuClick}>TVET PROGRAMS</Link>
              </li>
            </Submenu>
          </DropdownNavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('offices')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'offices'}
          >
            OFFICES
            <Submenu className={activeDropdown === 'offices' ? 'open' : ''}>
              <li>
                <Link to="/presidentoffice" style={{ color: 'white' }} onClick={handleSubmenuClick}>PRESIDENT OFFICE</Link>
              </li>
              <li>
                <Link to="/acdemicPresident" style={{ color: 'white' }} onClick={handleSubmenuClick}>ACADEMIC VICE PRESIDENT</Link>
              </li>
              <li>
                <Link to="/adminoffice" style={{ color: 'white' }} onClick={handleSubmenuClick}>ADMIN & FINANCE VICE PRESIDENT</Link>
              </li>
              <li>
                <Link to="/centralICT" style={{ color: 'white' }} onClick={handleSubmenuClick}>CENTRAL ICT</Link>
              </li>
              <li>
                <Link to="/centralRegistrar" style={{ color: 'white' }} onClick={handleSubmenuClick}>CENTRAL REGISTRAR</Link>
              </li>
              <li>
                <Link to="#" style={{ color: 'white' }} onClick={handleSubmenuClick}>CENTRAL LIBRARY OFFICE</Link>
              </li>
              <li>
                <Link to="/centralQuaity" style={{ color: 'white' }} onClick={handleSubmenuClick}>CENTRAL QUALITY ASSURANCE</Link>
              </li>
            </Submenu>
          </DropdownNavLink>

          <NavLink href="/allannouncement" style={{ color: 'white' }} aria-label="View blog and articles">BLOG & ARTICLES</NavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('eservice')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'eservice'}
          >
            E-SERVICES
            <Submenu className={activeDropdown === 'eservice' ? 'open' : ''}>
              <li>
                <a href="https://lms.admasuniversity.edu.et/login/index.php" target='_blank' style={{ color: 'white' }} onClick={handleSubmenuClick}>LMS</a>
              </li>
              <li>
                <a href="http://5.77.63.215:8080/" target='_blank' style={{ color: 'white' }} onClick={handleSubmenuClick}>LIBRARY</a>
              </li>
              <li>
                <a href="https://repository.admasuniversity.edu.et/" target='_blank' style={{ color: 'white' }} onClick={handleSubmenuClick}>REPOSITORY & DIGITAL LIBRARY</a>
              </li>
              <li>
                <Link to="/vacancy" style={{ color: 'white' }} onClick={handleSubmenuClick}>VACANCY</Link>
              </li>
            </Submenu>
          </DropdownNavLink>

          <NavLink href="/contact" style={{ color: 'white' }} aria-label="Contact us">CONTACT US</NavLink>
        </Navigation>

        <MenuButton onClick={toggleMenu} aria-label="Toggle menu">
          <Hamburger className={isMenuOpen ? 'open' : ''}>
            <span></span>
            <span></span>
            <span></span>
          </Hamburger>
        </MenuButton>

        <div className="search-btn">
          {location.pathname.includes('/ad-adm') && (
            <div className="link-btn">
              {isLogged ? (
                <Link to="/" className="theme-btn btn-style-one blue" onClick={handleLogout} aria-label="Log out">
                  Log out
                </Link>
              ) : (
                <Link to="/login" className="theme-btn btn-style-one" aria-label="Login">
                  Login
                </Link>
              )}
            </div>
          )}
        </div>
      </HeaderWrapper>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #1ab5f1;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 100;
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 4px;
`;

const Logo = styled.a`
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  text-decoration: none;
`;

const Navigation = styled.nav`
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: 1rem;
  color: #FFF;
  
  @media (max-width: 768px) {
    position: fixed;
    top: 168px;
    right: 0;
    width: 77%;
    height: 100vh;
    background: rgb(8, 8, 81);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    flex-direction: column;
    align-items: flex-start;
    padding: 2rem;
    transform: translateX(100%);
    transition: transform 0.3s ease;

    &.open {
      transform: translateX(0);
    }
  }
`;

const NavLink = styled.a`
  color: #FFF; 
  text-decoration: none;
  margin-left: 1rem;
  transition: color 0.3s ease;
  font-weight: bold;

  &:hover {
    color: #daa520;
  }

  @media (max-width: 768px) {
    margin-left: 0;
    margin-bottom: 1.5rem;
  }
`;

const DropdownNavLink = styled(NavLink)`
  position: relative;
  cursor: pointer;

  &.open {
    color: #fff;
  }
`;

const Submenu = styled.ul`
  display: none;
  position: absolute;
  background-color: rgba(11, 156, 213, 0.90);
  min-width: 260px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  padding: 0;
  margin: 0;
  list-style-type: none;

  li {
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    color: #fff; 

    &:hover {
      background-color: #1ab5f1;
      color: #fff;
    }
  }

  &.open {
    display: block;
  }
`;

const MenuButton = styled.button`
  display: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Hamburger = styled.div`
  span {
    display: block;
    width: 25px;
    height: 3px;
    background-color: #f5f7f7;
    margin-bottom: 5px;
    transition: all 0.3s ease;

    &:first-child,
    &:last-child {
      transform-origin: center;
    }

    &:first-child {
      transform: ${({ className }) =>
        className === 'open' ? 'translateY(8px) rotate(45deg)' : 'none'};
    }

    &:nth-child(2) {
      opacity: ${({ className }) => (className === 'open' ? '0' : '1')};
    }

    &:last-child {
      transform: ${({ className }) =>
        className === 'open' ? 'translateY(-8px) rotate(-45deg)' : 'none'};
    }
  }
`;

export default Header;
*/

/*
import React, { useState } from 'react';
import styled from 'styled-components';
import HeaderLogo from './HeaderLogo';
import HeaderTop from './HeaderTop';
import { useAuth } from '../../../context/AuthContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import loginService from '../../../services/login.service';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const { isLogged, setIsLogged } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown((prev) => (prev === dropdownName ? null : dropdownName));
  };

  const handleLogout = () => {
    setIsLogged(false);
    loginService.logOut();
    navigate('/');
  };

  // Function to handle submenu item click
  const handleSubmenuClick = (dropdownName) => {
    setActiveDropdown(null); // Close the dropdown
    if (isMenuOpen) {
      setIsMenuOpen(false); // Close the main menu on mobile
    }
  };

  return (
    <HeaderContainer>
      <HeaderTop />
      <HeaderWrapper>
        <Logo href="/" aria-label="Go to homepage">
          <HeaderLogo />
        </Logo>
        <Navigation className={isMenuOpen ? 'open' : ''}>
          <DropdownNavLink
            onClick={() => toggleDropdown('about')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'about'}
          >
            ABOUT
            <Submenu className={activeDropdown === 'about' ? 'open' : ''}>
              <li>
                <Link to="/history" style={{ color: 'white' }} onClick={() => handleSubmenuClick('about')}>OUR HISTORY</Link>
              </li>
              <li>
                <Link to="/mission" style={{ color: 'white' }} onClick={() => handleSubmenuClick('about')}>MISSION & VISION</Link>
              </li>
              <li>
                <Link to="/team" style={{ color: 'white' }} onClick={() => handleSubmenuClick('about')}>OUR LEADERS</Link>
              </li>
              <li>
                <a href="https://repository.admasuniversity.edu.et/staff_profile" target='_blank' style={{ color: 'white' }} onClick={() => handleSubmenuClick('about')}>ADU STAFF PROFILES</a>
              </li>
            </Submenu>
          </DropdownNavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('admission')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'admission'}
          >
            ADMISSION
            <Submenu className={activeDropdown === 'admission' ? 'open' : ''}>
              <li>
                <Link to="/overview" style={{ color: 'white' }} onClick={() => handleSubmenuClick('admission')}>OVERVIEW</Link>
              </li>
              <li>
                <Link to="/userUpcomingEvents" style={{ color: 'white' }} onClick={() => handleSubmenuClick('admission')}>CALENDAR</Link>
              </li>
              <li>
                <a href="https://aurs.admasuniversity.edu.et/Login" target='_blank' style={{ color: 'white' }} onClick={() => handleSubmenuClick('admission')}>REGISTRAR</a>
              </li>
            </Submenu>
          </DropdownNavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('academic')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'academic'}
          >
            ACADEMIC PROGRAMS
            <Submenu className={activeDropdown === 'academic' ? 'open' : ''}>
              <li>
                <Link to="/postgrad" style={{ color: 'white' }} onClick={() => handleSubmenuClick('academic')}>SCHOOL OF POSTGRADUATE STUDIES</Link>
              </li>
              <li>
                <Link to="/undergrad" style={{ color: 'white' }} onClick={() => handleSubmenuClick('academic')}>UNDERGRADUATE ACADEMIC PROGRAMS</Link>
              </li>
              <li>
                <Link to="/distance" style={{ color: 'white' }} onClick={() => handleSubmenuClick('academic')}>DISTANCE LEARNING PROGRAM</Link>
              </li>
              <li>
                <Link to="/tvet" style={{ color: 'white' }} onClick={() => handleSubmenuClick('academic')}>TVET PROGRAMS</Link>
              </li>
            </Submenu>
          </DropdownNavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('offices')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'offices'}
          >
            OFFICES
            <Submenu className={activeDropdown === 'offices' ? 'open' : ''}>
              <li>
                <Link to="/presidentoffice" style={{ color: 'white' }} onClick={() => handleSubmenuClick('offices')}>PRESIDENT OFFICE</Link>
              </li>
              <li>
                <Link to="/acdemicPresident" style={{ color: 'white' }} onClick={() => handleSubmenuClick('offices')}>ACADEMIC VICE PRESIDENT</Link>
              </li>
              <li>
                <Link to="/adminoffice" style={{ color: 'white' }} onClick={() => handleSubmenuClick('offices')}>ADMIN & FINANCE VICE PRESIDENT</Link>
              </li>
              <li>
                <Link to="/centralICT" style={{ color: 'white' }} onClick={() => handleSubmenuClick('offices')}>CENTRAL ICT</Link>
              </li>
              <li>
                <Link to="/centralRegistrar" style={{ color: 'white' }} onClick={() => handleSubmenuClick('offices')}>CENTRAL REGISTRAR</Link>
              </li>
              <li>
                <Link to="#" style={{ color: 'white' }} onClick={() => handleSubmenuClick('offices')}>CENTRAL LIBRARY OFFICE</Link>
              </li>
              <li>
                <Link to="/centralQuaity" style={{ color: 'white' }} onClick={() => handleSubmenuClick('offices')}>CENTRAL QUALITY ASSURANCE</Link>
              </li>
            </Submenu>
          </DropdownNavLink>

          <NavLink href="/allannouncement" style={{ color: 'white' }} aria-label="View blog and articles">BLOG & ARTICLES</NavLink>

          <DropdownNavLink
            onClick={() => toggleDropdown('eservice')}
            aria-haspopup="true"
            aria-expanded={activeDropdown === 'eservice'}
          >
            E-SERVICES
            <Submenu className={activeDropdown === 'eservice' ? 'open' : ''}>
              <li>
                <a href="https://lms.admasuniversity.edu.et/login/index.php" target='_blank' style={{ color: 'white' }} onClick={() => handleSubmenuClick('eservice')}>LMS</a>
              </li>
              <li>
                <a href="http://5.77.63.215:8080/" target='_blank' style={{ color: 'white' }} onClick={() => handleSubmenuClick('eservice')}>LIBRARY</a>
              </li>
              <li>
                <a href="https://repository.admasuniversity.edu.et/" target='_blank' style={{ color: 'white' }} onClick={() => handleSubmenuClick('eservice')}>REPOSITORY & DIGITAL LIBRARY</a>
              </li>
              <li>
                <Link to="/vacancy" style={{ color: 'white' }} onClick={() => handleSubmenuClick('eservice')}>VACANCY</Link>
              </li>
            </Submenu>
          </DropdownNavLink>

          <NavLink href="/contact" style={{ color: 'white' }} aria-label="Contact us">CONTACT US</NavLink>
        </Navigation>

        <MenuButton onClick={toggleMenu} aria-label="Toggle menu">
          <Hamburger className={isMenuOpen ? 'open' : ''}>
            <span></span>
            <span></span>
            <span></span>
          </Hamburger>
        </MenuButton>

        <div className="search-btn">
          {location.pathname.includes('/ad-adm') && (
            <div className="link-btn">
              {isLogged ? (
                <Link to="/" className="theme-btn btn-style-one blue" onClick={handleLogout} aria-label="Log out">
                  Log out
                </Link>
              ) : (
                <Link to="/login" className="theme-btn btn-style-one" aria-label="Login">
                  Login
                </Link>
              )}
            </div>
          )}
        </div>
      </HeaderWrapper>
    </HeaderContainer>
  );
};

const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #1ab5f1;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 100;
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 4px;
`;

const Logo = styled.a`
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  text-decoration: none;
`;

const Navigation = styled.nav`
  display: flex;
  align-items: center;
  font-size: 1rem;
  color: #FFF;
  
  @media (max-width: 768px) {
    position: fixed;
    top: 168px;
    right: 0;
    width: 77%;
    height: 100vh;
    background: rgb(8, 8, 81);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    flex-direction: column;
    align-items: flex-start;
    padding: 2rem;
    transform: translateX(100%);
    transition: transform 0.3s ease;

    &.open {
      transform: translateX(0);
    }
  }
`;

const NavLink = styled.a`
  color: #FFF; 
  text-decoration: none;
  margin-left: 1rem;
  transition: color 0.3s ease;
  font-weight: bold;

  &:hover {
    color: #daa520;
  }

  @media (max-width: 768px) {
    margin-left: 0;
    margin-bottom: 1.5rem;
  }
`;

const DropdownNavLink = styled(NavLink)`
  position: relative;
  cursor: pointer;

  &.open {
    color: #fff;
  }
`;

const Submenu = styled.ul`
  display: none;
  position: absolute;
  background-color: rgba(11, 156, 213, 0.90);
  min-width: 260px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  padding: 0;
  margin: 0;
  list-style-type: none;

  li {
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    color: #fff; 

    &:hover {
      background-color: #1ab5f1;
      color: #fff;
    }
  }

  &.open {
    display: block;
  }
`;

const MenuButton = styled.button`
  display: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Hamburger = styled.div`
  span {
    display: block;
    width: 25px;
    height: 3px;
    background-color: #f5f7f7;
    margin-bottom: 5px;
    transition: all 0.3s ease;

    &:first-child,
    &:last-child {
      transform-origin: center;
    }

    &:first-child {
      transform: ${({ className }) =>
        className === 'open' ? 'translateY(8px) rotate(45deg)' : 'none'};
    }

    &:nth-child(2) {
      opacity: ${({ className }) => (className === 'open' ? '0' : '1')};
    }

    &:last-child {
      transform: ${({ className }) =>
        className === 'open' ? 'translateY(-8px) rotate(-45deg)' : 'none'};
    }
  }
`;

export default Header;

*/

import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import HeaderLogo from './HeaderLogo';
import HeaderTop from './HeaderTop';
import NavLinks from './NavLink';
import { useAuth } from '../../../context/AuthContext';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import loginService from '../../../services/login.service';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null);
  const { isLogged, setIsLogged, employee } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();
console.log(useAuth());
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleDropdownEnter = (dropdownName) => {
    setActiveDropdown(dropdownName);
  };

  const handleDropdownLeave = () => {
    setActiveDropdown(null);
  };

  const handleLogout = () => {
    setIsLogged(false);
    loginService.logOut();
    navigate('/');
  };

  return (
    <HeaderContainer>
      <HeaderTop />
      <HeaderWrapper>
        <Logo href="/"><HeaderLogo /></Logo>
        <Navigation className={isMenuOpen ? 'open' : ''}>
         
          <DropdownNavLink
            href="#"
            className={activeDropdown === 'about' ? 'open' : ''}
            onMouseEnter={() => handleDropdownEnter('about')}
            onMouseLeave={handleDropdownLeave}
          >
            About
            <Submenu className={activeDropdown === 'about' ? 'open' : ''}>
              <li><a href="/history" style={{color:'white'}}>Our History</a></li>
              <li><a href="/mission" style={{color:'white'}}>Mission & Vission</a></li>
              <li><a href="/team" style={{color:'white'}}>ADU Leaders</a></li>
              <li><a href="https://repository.admasuniversity.edu.et/staff_profile" target='_blank' style={{color:'white'}}>ADU Staff Profiles</a></li>
              
            </Submenu>
          </DropdownNavLink>
       

          <DropdownNavLink
            href="#"
            className={activeDropdown === 'admission' ? 'open' : ''}
            onMouseEnter={() => handleDropdownEnter('admission')}
            onMouseLeave={handleDropdownLeave}
          >
            Admission
            <Submenu className={activeDropdown === 'admission' ? 'open' : ''}>
              <li><a href="/overview" style={{color:'white'}}>Overview</a></li>
              <li><a href="/userUpcomingEvents" style={{color:'white'}}>Calander</a></li>
              <li><a href="https://aurs.admasuniversity.edu.et/Login" target='_blank'  style={{color:'white'}}>Registrar</a></li>
              
            </Submenu>
          </DropdownNavLink>

     
          <DropdownNavLink
            href="#"
            className={activeDropdown === 'academic' ? 'open' : ''}
            onMouseEnter={() => handleDropdownEnter('academic')}
            onMouseLeave={handleDropdownLeave}
          >
            Academic Programs
            <Submenu className={activeDropdown === 'academic' ? 'open' : ''}>
              <li><a href="/postgrad"style={{color:'white'}}>School of Postgraduate Studies</a></li>
              <li><a href="/undergrad" style={{color:'white'}}>Undergraduate Academic Programs</a></li>
              <li><a href="/distance"style={{color:'white'}}>Distance Learning Program</a></li>
              <li><a href="/tvet"style={{color:'white'}}>TVET Programs</a></li>
            </Submenu>
          </DropdownNavLink>

          <DropdownNavLink
            href="#"
            className={activeDropdown === 'Outreach' ? 'open' : ''}
            onMouseEnter={() => handleDropdownEnter('Outreach')}
            onMouseLeave={handleDropdownLeave}
          >
            Offices
            <Submenu className={activeDropdown === 'Outreach' ? 'open' : ''}>
              
              <li><a href="/presidentoffice" style={{color:'white'}}>President Office</a></li>
              <li><a href="/acdemicPresident" style={{color:'white'}}>Academic Vice President</a></li>
              <li><a href="/adminoffice" style={{color:'white'}}>Admin & Finance Vice President</a></li>
              <li><a href="#" style={{color:'white'}}>Central ICT</a>
              <li><a href="/training" style={{color:'white'}}>Consultancy & Training</a></li>
              
              </li>
              <li><a href="#" style={{color:'white'}}>Central Library Office</a></li>
              <li><a href="/centralQuaity"style={{color:'white'}}>Central Quality Assurance</a></li>
            </Submenu>
          </DropdownNavLink>
       
          <NavLink href="/allannouncement" style={{color:'white'}}>Blog & Articles</NavLink>
          <DropdownNavLink
            href="#"
            className={activeDropdown === 'eservice' ? 'open' : ''}
            onMouseEnter={() => handleDropdownEnter('eservice')}
            onMouseLeave={handleDropdownLeave}
          >
         e-Services
            <Submenu className={activeDropdown === 'eservice' ? 'open' : ''}>
              <li><a href="https://lms.admasuniversity.edu.et/login/index.php" target='_blank' style={{color:'white'}}>LMS</a></li>
              <li><a href="http://5.77.63.215:8080/" target='_blank' style={{color:'white'}}>Library</a></li>
              <li><a href="https://repository.admasuniversity.edu.et/" target='_blank' style={{color:'white'}}>Repository & Digital Library</a></li> 
                      
              <li><a href="/vacancy" style={{color:'white'}}>Vacancy</a></li>          
           
            </Submenu>
          </DropdownNavLink>

          <NavLink href="/contact" style={{color:'white'}}>Contact</NavLink>
</Navigation>

        <MenuButton onClick={toggleMenu}>
          <Hamburger className={isMenuOpen ? 'open' : ''}>
            <span></span>
            <span></span>
            <span></span>
          </Hamburger>
        </MenuButton>
        <div className="search-btn">
          {location.pathname.includes('/ad-adm') && (
            <div className="link-btn">
              {isLogged ? (
                <Link to="/" className="theme-btn btn-style-one blue" onClick={handleLogout}>
                  Log out
                </Link>
              ) : (
                <Link to="/login" className="theme-btn btn-style-one">
                  Login
                </Link>
              )}
            </div>
          )}
        </div>
      </HeaderWrapper>
    </HeaderContainer>
  );
};

export default Header;


const HeaderContainer = styled.header`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background-color: #1ab5f1;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  z-index: 100;
`;

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding-top: 10px;
  padding-left: 10px;
  padding-bottom: 4px;
`;

const Logo = styled.a`
  font-size: 1rem;
  font-weight: bold;
  color: #333;
  text-decoration: none;
`;

const Navigation = styled.nav`
  display: flex;
  align-items: center;
  font-size: 1rem;
  color:#FFF;

  @media (max-width: 768px) {
    position: fixed;
    top: 168px;
    right: 0;
    width: 77%;
    height: 100vh;
    background: rgb(8, 8, 81);
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    flex-direction: column;
    align-items: flex-start;
    padding: 2rem;
    transform: translateX(100%);
    transition: transform 0.3s ease;

    &.open {
      transform: translateX(0);
    }
  }
`;

const NavLink = styled.a`
  color: #FFF; 
  text-decoration: none;
  margin-left: 1rem;
  transition: color 0.3s ease;
  font-weight:bold;
  &:hover {
    color: #daa520;
  }

  @media (max-width: 768px) {
    margin-left: 0;
    margin-bottom: 1.5rem;
  }
`;

const DropdownNavLink = styled(NavLink)`
  position: relative;
  cursor: pointer;

  &.open {
    color: #fff;
  }
`;

const Submenu = styled.ul`
  display: none;
  position: absolute;
  background-color: rgba(11, 156, 213, 0.93);
  min-width: 260px;
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  z-index: 1;
  padding: 0;
  margin: 0;
  list-style-type: none;

  li {
    padding: 12px 16px;
    text-decoration: none;
    display: block;
    color: #fff; 

    &:hover {
      background-color: #1ab5f1;
      color: #fff;
    }
  }

  &.open {
    display: block;
  }
`;

const MenuButton = styled.button`
  display: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0.5rem;

  @media (max-width: 768px) {
    display: block;
  }
`;

const Hamburger = styled.div`
  span {
    display: block;
    width: 25px;
    height: 3px;
    background-color: #f5f7f7;
    margin-bottom: 5px;
    transition: all 0.3s ease;

    &:first-child,
    &:last-child {
      transform-origin: center;
    }

    &:first-child {
      transform: ${({ className }) =>
        className === 'open' ? 'translateY(8px) rotate(45deg)' : 'none'};
    }

    &:nth-child(2) {
      opacity: ${({ className }) => (className === 'open' ? '0' : '1')};
    }

    &:last-child {
      transform: ${({ className }) =>
        className === 'open' ? 'translateY(-8px) rotate(-45deg)' : 'none'};
    }
  }
`;

// Styled components for the AdminButton
const AdminButton = styled.a`
  padding: 10px 20px;
  background-color: #daa520;
  color: #fff;
  text-decoration: none;
  border-radius: 5px;
  margin-left: 20px;
`;





